'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import Button from '@/components/LegacyButton';
import Spacer from '@/components/Spacer';

const EpilepsyWarning = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [reveal, setReveal] = React.useState(false);

  if (!reveal) {
    return (
      <DefaultWrapper>
        <p>
          <strong>Warning:</strong> This GIF includes flickering
          motion that may potentially trigger seizures for people with
          photosensitive epilepsy.
        </p>
        <Spacer size={32} />
        <Button onClick={() => setReveal(true)}>Reveal</Button>
      </DefaultWrapper>
    );
  }

  return children;
};

const DefaultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--color-gray-300);
  padding: 16px;
  margin-bottom: 32px;

  p {
    font-size: 1.125rem;
    max-width: 37.5rem;
    margin: auto;
    text-align: center;
    text-wrap: balance;
  }
`;

export default EpilepsyWarning;
